import { MenuItems } from "./getItemsMenu";

export const getHeaderBarColor = (label) => {
  const item = MenuItems.find((menuItem) => menuItem.label === label);
  return item ? item.color : "#1890FF"; // fallback a azul si no se encuentra
};
